import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-incidents-create-incident-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class IncidentsCreateApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.createNewIncident"),
            description: this.translation.t("specs.createNewIncidentDescription"),
            httpMethod: "POST",
            path: "/incidents",

            parameters: [
                {
                    name: "ClassificationId",
                    description: this.translation.t("parameters.incidentClassificationIdDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "OrganizationId",
                    description: this.translation.t("parameters.incidentOrganizationIdDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "ReportedById",
                    description: this.translation.t("parameters.incidentReportedByIdDescription"),
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "Name",
                    description: this.translation.t("parameters.createNewIncidentNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "Incident Name",
                },
                {
                    name: "Description",
                    description: this.translation.t("parameters.createNewIncidentDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Incident Description",
                },
                {
                    name: "OccurredOn",
                    description: this.translation.t("parameters.incidentOccurredOnDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "2023-01-01T12:00:00Z",
                },
                {
                    name: "DetectedOn",
                    description: this.translation.t("parameters.incidentDetectedOnDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "2023-01-01T12:00:00Z",
                },
                {
                    name: "DueDate",
                    description: this.translation.t("parameters.incidentDueDateDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "2023-01-01T12:00:00Z",
                },
                {
                    name: "RootCause",
                    description: this.translation.t("parameters.incidentRootCauseDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Root cause of the incident",
                },
                {
                    name: "InternalIdentifier",
                    description: this.translation.t("parameters.incidentInternalIdentifierDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "Internal Identifier",
                },
                {
                    name: "Impact",
                    description: this.translation.t("parameters.incidentImpactDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "High",
                },
                {
                    name: "IncidentTypeIds",
                    description: this.translation.t("parameters.incidentTypeIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "BusinessDimensionIds",
                    description: this.translation.t("parameters.incidentBusinessDimensionIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "FrameworkDimensionIds",
                    description: this.translation.t("parameters.incidentFrameworkDimensionIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "RootCauseCategoryIds",
                    description: this.translation.t("parameters.incidentRootCauseCategoryIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "CausedByOrganizationIds",
                    description: this.translation.t("parameters.incidentCausedByOrganizationIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "AffectedOrganizationIds",
                    description: this.translation.t("parameters.incidentAffectedOrganizationIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "CausedByThirdPartyIds",
                    description: this.translation.t("parameters.incidentCausedByThirdPartyIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "AffectedThirdPartyIds",
                    description: this.translation.t("parameters.incidentAffectedThirdPartyIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "ResponsibleIds",
                    description: this.translation.t("parameters.incidentResponsibleIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "AssessorIds",
                    description: this.translation.t("parameters.incidentAssessorIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "InformedIds",
                    description: this.translation.t("parameters.incidentInformedIdsDescription"),
                    in: "body",
                    paramType: "array of uuids",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000001",
                    ],
                },
                {
                    name: "IncidentCustomFields",
                    description: this.translation.t("parameters.incidentCustomFieldsDescription"),
                    in: "body",
                    paramType: "array of models",
                    required: false,
                    example: [
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000001",
                            Value: "1",
                        },
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000002",
                            Value: "api custom field text",
                        },
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000004",
                            Value: "2025-03-15",
                        },
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000004",
                            Value: "2026-03-30T09:30:00.0000000Z",
                        },
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000005",
                            Value: "true",
                        },
                        {
                            CustomFieldId: "00000000-0000-0000-0000-000000000006",
                            Value: "00000000-0000-0000-0000-000000000009,00000000-0000-0000-0000-000000000007",
                        },
                    ],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
